import React, { useState, useEffect } from 'react';
import { Form } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { addPrescription, getPrescription, upatePrescription, upatePrescriptionStatus } from "../../Api/prescriptionApis";
import Spinner from 'react-bootstrap/Spinner';
import { getCurrentUser } from "../../Api/auth";
import Modal from 'react-bootstrap/Modal';
import { FaStar } from "react-icons/fa";
import { getInventoryByType } from "../../Api/inventoryApi";
import { getModeldatabymake } from "../../Api/inventoryApi";


const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};

function PrescriptionLeft({ project_id, disablestatus, prescriptiondata, allmodels, allMakeData, ongetChange }) {

    
    const [prescription, setPrescription] = useState(initialPrescriptionState);
    const [apicall, setApicall] = useState(false);
    const [prescriptionid, setPrescriptionid] = useState(null);
    const [selectedOption2, setSelectedOption2] = useState('Prescribed');
    const [status, setStatus] = useState('');
    const [userdata, setUserdata] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);


    const [optimalHeads, setOptimalHeads] = useState(0);
    const [optimalShafts, setOptimalShafts] = useState(0);
    const [optimalGrips, setOptimalGrips] = useState(0);


    const [head1, setHead1] = useState('');
    const [head2, setHead2] = useState('');
    const [head3, setHead3] = useState('');

    const [Shaft1, setShaft1] = useState('');
    const [Shaft2, setShaft2] = useState('');
    const [Shaft3, setShaft3] = useState('');

    const [Grip1, setGrip1] = useState('');
    const [Grip2, setGrip2] = useState('');
    const [Grip3, setGrip3] = useState('');

    const [makedata, setMakeData] = useState([]);

    const [validated, setValidated] = useState(false);

    const params = useParams();
    const [show03, setShow03] = useState(false);

    const handleClose03 = () => setShow03(false);
    const handleShow03 = () => setShow03(true);
    const [errors, setErrors] = useState([]);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);

    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        // getInventoryByType(data).then((response) => {
        //     if (!response.data.status) {
        //         console.log(response.data.message);
        //     } else {
        //         const data = response.data.data;
        //         if(id === 4){
        //             setMakeData(data);
        //         }
        //         if(id === 7){
        //             setShaftData(data);
        //         } 
        //         if(id === 8){
        //             setGripData(data);
        //         }
        //     }
        // }
        // ).catch((err) => {
        //     console.log(err);
        // });
        const filtermakedata = allMakeData && allMakeData.filter((item) => item.item_type_id.includes(id));
        if (id === 4) {
            setMakeData(filtermakedata);
        }
        if (id === 7) {
            setShaftData(filtermakedata);
        }
        if (id === 8) {
            setGripData(filtermakedata);
        }
    }


    const handleChange = (field, value) => {
        setPrescription(prevState => ({
            ...prevState,
            [field]: value
        }));
    };



    const handleNestedChange = (section, option, subField, value) => {
        // Determine type_id based on the section
        let type_id = "";
        switch (section) {
            case "optimalHeads":
                type_id = "4";
                break;
            case "optimalShafts":
                type_id = "7";
                break;
            case "optimalGrips":
                type_id = "8";
                break;
            default:
                break;
        }

        // Filter the models from allmodels array
        const filteredModels = allmodels.filter(model =>
            model.Make === value && model.type_id === type_id
        );

        // Set the data based on section, subField, and option
        if (filteredModels.length > 0) {
            const data = filteredModels;

            if (section === 'optimalHeads') {
                switch (option) {
                    case 1:
                        setHead1(data);
                        break;
                    case 2:
                        setHead2(data);
                        break;
                    case 3:
                        setHead3(data);
                        break;
                    default:
                        break;
                }
            }

            if (section === 'optimalShafts') {
                switch (option) {
                    case 1:
                        setShaft1(data);
                        break;
                    case 2:
                        setShaft2(data);
                        break;
                    case 3:
                        setShaft3(data);
                        break;
                    default:
                        break;
                }
            }

            if (section === 'optimalGrips') {
                switch (option) {
                    case 1:
                        setGrip1(data);
                        break;
                    case 2:
                        setGrip2(data);
                        break;
                    case 3:
                        setGrip3(data);
                        break;
                    default:
                        break;
                }
            }
        } else {
            console.log("");
        }

        // Update the prescription state
        setPrescription(prevState => ({
            ...prevState,
            [section]: {
                ...prevState[section],
                [`option${option}`]: {
                    ...(prevState[section] && prevState[section][`option${option}`]),
                    [subField]: value
                }
            }
        }));
    };



    const handlesaveproject = () => {
        setApicall(true);
        const data = {
            'prescription': JSON.stringify(prescription),
            'project_id': project_id
        }
        addPrescription(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicall(false);
                window.scrollTo(0, 0);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const [incearement, setIncearement] = useState(1);

    const handleupateproject = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setValidated(true);
            handleShow();
        }
        // else if (optimalHeads == 0 || optimalShafts == 0 || optimalGrips == 0) {
        //     event.preventDefault();
        //     event.stopPropagation();
        //     setValidated(true);
        //     handleShow();
        // }
        else {
            setApicall(true);
            const data = {
                'prescription': JSON.stringify(prescription),
                'id': prescriptionid,
                'user_id': userdata._id,
                'fitter_name': userdata.firstname + " " + userdata.lastname,
                "optimalHeads": optimalHeads,
                "optimalShafts": optimalShafts,
                "optimalGrips": optimalGrips
            }
            upatePrescription(data).then((res) => {
                console.log("res", res);
                if (!res.data.status) {
                    setErrors(res.data.data);
                    alert(res.data.data[0].detail);
                } else {
                    setApicall(false);
                    getprojectdata();
                    setIncearement(prevIncearement => prevIncearement + 1);
                    ongetChange(incearement + 1);
                }

            }).catch((error) => {
                console.log("error", error);
            }).finally(() => {
                // handleShow03();
                // window.scrollTo(0, 0);
                handleApiResponse();
                setApicall(false);
            });
        }
    }

    const getprojectdata = () => {
        // setApicall(true);
        // getPrescription({ project_id: project_id }).then((res) => {
        //     console.log("calling api", "2");
        //     if (!res.data.status) {
        //         setErrors(res.data.data);
        //         alert(res.data.data[0].detail);
        //     } else {
        //         // setApicall(false); 
        //         setPrescription(res.data.data);
        //         setbrandsData(res.data.data);
        //         setPrescriptionid(res.data.data._id);
        //         const status = res.data.data.status;
        //         const upercasestatus = (status).charAt(0).toUpperCase() + (status).slice(1);
        //         setSelectedOption2(upercasestatus);
        //         setStatus(status);
        //         setOptimalHeads(parseInt(res.data.data.optimalHeadsStar));
        //         setOptimalShafts(parseInt(res.data.data.optimalShaftsStar));
        //         setOptimalGrips(parseInt(res.data.data.optimalGripsStar));
        //     }

        // }).catch((error) => {
        //     console.log("error", error);
        // });

        if (prescriptiondata) {
            setPrescription(prescriptiondata);
            setbrandsData(prescriptiondata);
            setPrescriptionid(prescriptiondata._id);
            const status = prescriptiondata.status;
            const upercasestatus = (status).charAt(0).toUpperCase() + (status).slice(1);
            setSelectedOption2(upercasestatus);
            setStatus(status);
            setOptimalHeads(parseInt(prescriptiondata.optimalHeadsStar));
            setOptimalShafts(parseInt(prescriptiondata.optimalShaftsStar));
            setOptimalGrips(parseInt(prescriptiondata.optimalGripsStar));
        }
    }

    const setbrandsData = (data) => {


        handleNestedChange('optimalHeads', 1, 'make', data?.optimalHeads?.option1?.make ?? '');
        handleNestedChange('optimalHeads', 2, 'make', data?.optimalHeads?.option2?.make ?? '');
        handleNestedChange('optimalHeads', 3, 'make', data?.optimalHeads?.option3?.make ?? '');
        
        handleNestedChange('optimalShafts', 1, 'make', data?.optimalShafts?.option1?.make ?? '');
        handleNestedChange('optimalShafts', 2, 'make', data?.optimalShafts?.option2?.make ?? '');
        handleNestedChange('optimalShafts', 3, 'make', data?.optimalShafts?.option3?.make ?? '');
        
        handleNestedChange('optimalGrips', 1, 'make', data?.optimalGrips?.option1?.make ?? '');
        handleNestedChange('optimalGrips', 2, 'make', data?.optimalGrips?.option2?.make ?? '');
        handleNestedChange('optimalGrips', 3, 'make', data?.optimalGrips?.option3?.make ?? '');
        

    }

    useEffect(() => {
        setbrandsData(prescription);
    }, [prescription]);

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        getmakedata(4);
        getmakedata(7);
        getmakedata(8);
        getprojectdata();
        window.scrollTo(0, 0);
        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }
    }, []);


    const handleApiResponse = () => {
        // Scroll to top
        window.scrollTo(0, 0);

        // Show modal
        setShow03(true);
    };

    useEffect(() => {
        if (disablestatus) {
            setIsDisabled(true);
        }
    }, [disablestatus]);

    return (
        <>
            <Modal
                show={show03}
                // onHide={handleClose03}
                onHide={() => {
                    handleClose03();
                    window.scrollTo(0, 0);

                }}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        Success!
                    </h2>
                    <p className="text-center mb-4">
                        Your data added successfully.
                    </p>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose03}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        You missed something!
                    </h2>
                    <p className="text-center mb-4">
                        Please fill out every input field in this section before moving on to the next section.
                    </p>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>
            <Form noValidate validated={validated} onSubmit={handleupateproject}>
                <fieldset disabled={isDisabled}>
                    <div className="listing-box">
                        <div className="black_bg_box mt-0">
                            <div className="club-fitting-card">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Bounce</h5></div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <textarea className="dashboard-text-area" value={prescription.bounce} onChange={(e) => handleChange('bounce', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add bounce prescription..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid bounce.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className="club-fitting-card black_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Lie Angle</h5></div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <textarea className="dashboard-text-area" value={prescription.lieage} onChange={(e) => handleChange('lieage', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add lie angle prescription..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid bounce.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className="club-fitting-card blue_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Shaft Weight</h5></div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <textarea className="dashboard-text-area" value={prescription.shaftweight} onChange={(e) => handleChange('shaftweight', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add shaft weight prescription..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid bounce.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className="club-fitting-card pink_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Shaft Flex</h5></div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription.shaftflex} onChange={(e) => handleChange('shaftflex', e.target.value)} rows="10" placeholder="Add shaft flex prescription..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid bounce.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className="club-fitting-card purple_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Shaft Profile</h5></div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <textarea className="dashboard-text-area" value={prescription.shaftprofile} onChange={(e) => handleChange('shaftprofile', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add shaft profile prescription..." required></textarea>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className="club-fitting-card red_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Grip Size</h5></div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <textarea className="dashboard-text-area" value={prescription.gripSize} onChange={(e) => handleChange('gripSize', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add grip size prescription..." required></textarea>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className="club-fitting-card orange_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Club Length</h5></div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription.clubLength} onChange={(e) => handleChange('clubLength', e.target.value)} rows="10" placeholder="Add club length prescription..." required></textarea>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className="club-fitting-card green_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Swing Weight</h5></div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription.swingWeight} onChange={(e) => handleChange('swingWeight', e.target.value)} rows="10" placeholder="Add swing weight prescription..." required></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="listing-box">
                        <div className="sec-middle-title">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Optimal Heads</h3>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Head 1
                                </div>
                                <div
                                    // className={`black_star_box ${validated === true && optimalHeads === 0 ? 'head_star_error' : ''} ${optimalHeads === 1 ? 'active' : ''}`}
                                    className={`black_star_box ${optimalHeads === 1 ? 'active' : ''}`}
                                    onClick={() => isDisabled ? null : setOptimalHeads(1)} >
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalHeads?.option1?.make || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" onChange={(e) => handleNestedChange('optimalHeads', 1, 'make', e.target.value)} aria-label="Default select example" required={optimalHeads === 1}>
                                    <option value='' disabled>Make</option>
                                    {makedata && makedata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalHeads?.option1?.modal || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" onChange={(e) => handleNestedChange('optimalHeads', 1, 'modal', e.target.value)} aria-label="Default select example" required={optimalHeads === 1}>
                                    <option value='' disabled>Model</option>
                                    {head1 && head1.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Head 2
                                </div>
                                <div className={`black_star_box  ${optimalHeads === 2 ? 'active' : ''}`}
                                    onClick={() => isDisabled ? null : setOptimalHeads(2)}>
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalHeads?.option2?.make || ""} onChange={(e) => handleNestedChange('optimalHeads', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalHeads === 2}>
                                    <option value='' disabled>Make</option>
                                    {makedata && makedata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalHeads?.option2?.modal || ""} onChange={(e) => handleNestedChange('optimalHeads', 2, 'modal', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalHeads === 2}>
                                    <option value='' disabled>Model</option>
                                    {head2 && head2.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Head 3
                                </div>
                                <div className={`black_star_box ${optimalHeads === 3 ? 'active' : ''}`}
                                    onClick={() => isDisabled ? null : setOptimalHeads(3)}>
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalHeads?.option3?.make || ''} onChange={(e) => handleNestedChange('optimalHeads', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalHeads === 3}>
                                    <option value='' disabled>Make</option>
                                    {makedata && makedata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalHeads?.option3?.modal || ''} onChange={(e) => handleNestedChange('optimalHeads', 3, 'modal', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalHeads === 3}>
                                    <option value='' disabled>Model</option>
                                    {head3 && head3.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>
                    <div className="listing-box">
                        <div className="sec-middle-title">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Optimal Shafts</h3>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Shafts 1
                                </div>
                                <div className={`black_star_box  ${optimalShafts === 1 ? 'active' : ''}`} onClick={() => isDisabled ? null : setOptimalShafts(1)}>
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalShafts?.option1?.make || ''} class="form-select form-control dashboard-input-box-3 select-custom-boxx" onChange={(e) => handleNestedChange('optimalShafts', 1, 'make', e.target.value)} aria-label="Default select example" required={optimalShafts === 1}>
                                    <option value='' disabled>Make</option>
                                    {shaftdata && shaftdata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalShafts?.option1?.model || ''} class="form-select form-control dashboard-input-box-3 select-custom-boxx" onChange={(e) => handleNestedChange('optimalShafts', 1, 'model', e.target.value)} aria-label="Default select example" required={optimalShafts === 1}>
                                    <option value='' disabled>Model</option>
                                    {Shaft1 && Shaft1.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Shafts 2
                                </div>
                                <div className={`black_star_box  ${optimalShafts === 2 ? 'active' : ''}`} onClick={() => isDisabled ? null : setOptimalShafts(2)}>
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalShafts?.option2?.make || ''} onChange={(e) => handleNestedChange('optimalShafts', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalShafts === 2}>
                                    <option value='' disabled>Make</option>
                                    {shaftdata && shaftdata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalShafts?.option2?.model || ''} onChange={(e) => handleNestedChange('optimalShafts', 2, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalShafts === 2}>
                                    <option value='' disabled>Model</option>
                                    {Shaft2 && Shaft2.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Shafts 3
                                </div>
                                <div className={`black_star_box  ${optimalShafts === 3 ? 'active' : ''}`} onClick={() => isDisabled ? null : setOptimalShafts(3)}>
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalShafts?.option3?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalShafts === 3}>
                                    <option value='' disabled>Make</option>
                                    {shaftdata && shaftdata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalShafts?.option3?.model || ""} onChange={(e) => handleNestedChange('optimalShafts', 3, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalShafts === 3}>
                                    <option value='' disabled>Model</option>
                                    {Shaft3 && Shaft3.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>
                    <div className="listing-box">
                        <div className="sec-middle-title">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Optimal Grips</h3>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Grips 1
                                </div>
                                <div className={`black_star_box   ${optimalGrips === 1 ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`} onClick={() => isDisabled ? null : setOptimalGrips(1)}>
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalGrips?.option1?.make || ''} onChange={(e) => handleNestedChange('optimalGrips', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalGrips === 1}>
                                    <option value='' disabled>Make</option>
                                    {gripdata && gripdata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalGrips?.option1?.model || ''} onChange={(e) => handleNestedChange('optimalGrips', 1, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalGrips === 1}>
                                    <option value='' disabled>Model</option>
                                    {Grip1 && Grip1.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Grips 2
                                </div>
                                <div className={`black_star_box   ${optimalGrips === 2 ? 'active' : ''}`} onClick={() => isDisabled ? null : setOptimalGrips(2)}>
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalGrips?.option2?.make || ''} onChange={(e) => handleNestedChange('optimalGrips', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalGrips === 2}>
                                    <option value='' disabled>Make</option>
                                    {gripdata && gripdata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalGrips?.option2?.model || ''} onChange={(e) => handleNestedChange('optimalGrips', 2, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalGrips === 2}>
                                    <option value='' disabled>Model</option>
                                    {Grip2 && Grip2.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box">
                            <div className='blace_bg_box_head'>
                                <div className="black_bg_box_title">
                                    Grips 3
                                </div>
                                <div className={`black_star_box   ${optimalGrips === 3 ? 'active' : ''}`} onClick={() => isDisabled ? null : setOptimalGrips(3)}>
                                    <FaStar />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                <select value={prescription?.optimalGrips?.option3?.make} onChange={(e) => handleNestedChange('optimalGrips', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalGrips === 3}>
                                    <option value='' disabled>Make</option>
                                    {gripdata && gripdata.map((item) => (
                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                <select value={prescription?.optimalGrips?.option3?.model} onChange={(e) => handleNestedChange('optimalGrips', 3, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required={optimalGrips === 3}>
                                    <option value='' disabled>Model</option>
                                    {Grip3 && Grip3.map((item) => (
                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                    ))}
                                </select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Dexterity
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>
                    <div className="btn-box-section btn-inline-box">
                        <button className="btn btn-primary btn-remove">Remove Prescipation</button>
                        {/* {
                                                        prescriptionid !== null 
                                                        <button className="btn btn-primary btn-create" onClick={handlesaveproject}>{apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Save Project</span>)}</button>
                                                        <button className="btn btn-primary btn-create" onClick={handlesaveproject}>{apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Update Project</span>)}</button>
                                                    } */}

                        <>
                            {
                                prescriptionid === null || prescriptionid === undefined
                                    ? (
                                        <button className="btn btn-primary btn-create" onClick={handlesaveproject}>
                                            {apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Save Project</span>)}
                                        </button>
                                    )
                                    : (
                                        <button className="btn btn-primary btn-create" type='submit'>
                                            {apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Update Project</span>)}
                                        </button>
                                    )
                            }
                        </>

                    </div>
                </fieldset>
            </Form>
        </>
    );
}

export default PrescriptionLeft;